import { Drawer } from "antd";
import styles from "./FileListDrawer.module.scss";
import { DrawerConstants, mockData, drawerContents } from "./constants";
import { DrawerHeaderStyle } from "../../../../constants/CustomStyles";
import clsx from "clsx";
import TNButton from "../../../../reusable-components/TNButton";
import { ButtonType } from "../../../../enums/ButtonAttributesEnums";
import LienProcessingService from "../../../../services/lienProcess.service";
import { useEffect, useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";
import { directDownloadUtil, downloadUtil } from "../../../../utils/downloadUtil";
import TNLoader from "../../../../reusable-components/TNLoader";
import ConditionalRender from "../../../../reusable-components/ConditionalRender";

interface FileListDrawerProps {
  isOpen?: boolean;
  closeDrawer?: () => void;
}

const FileListDrawer = (props?: FileListDrawerProps) => {
  const isMountRef = useRef<boolean>(true);
  const location = useLocation();
  const batchId = location?.pathname?.split("/")?.at(-1);
  const { isOpen, closeDrawer } = props;
  const { TITLE, WIDTH, BUTTON_LABEL } = DrawerConstants;
  const { FetchBatchDocuments } = LienProcessingService(isOpen);
  const { data, refetch, isFetching: batchPending } = FetchBatchDocuments(batchId, isOpen);

  useEffect(() => {
    if(isMountRef) {
      isMountRef.current = false;
      return;
    }
    refetch();
  }, [batchId]);

  const documentData = useMemo(() => data?.data, [data?.data]);

  return (
    <>
      <TNLoader isLoading={batchPending}/>
      <Drawer
        visible={isOpen}
        onClose={closeDrawer}
        title={TITLE}
        headerStyle={DrawerHeaderStyle}
        className={styles.Drawer}
        width={WIDTH}
        destroyOnClose
      >
        <TNButton
          text={BUTTON_LABEL}
          className={styles.button}
          onClick={() => {
            directDownloadUtil(data?.data?.documentsZipUrl)
          }}
        />
        {Object.keys(drawerContents)
          .filter((item) => Object.keys(data?.data ?? {}).includes(item))
          .map((item) => (
            <div key={item} className={styles.drawerContainer}>
              <div className={styles.header}>{drawerContents?.[item]?.[0]}</div>
              <div
                className={clsx(styles.content, {
                  [styles.allForms]: item === "documentsZipUrl",
                })}
              >
                {item !== "rateAgreementDocs" ? (
                  <>
                    <img
                      src={drawerContents[item][1]}
                      className={styles.imageSize}
                      alt=""
                    />
                    <span
                      className={styles.label}
                      onClick={() => directDownloadUtil(data?.data[item])}
                    >
                      {drawerContents[item][2]}
                    </span>
                  </>
                ) : (
                  <>
                    {documentData.rateAgreementDocs &&
                      Object.values(documentData.rateAgreementDocs).map(
                        (val, index) => (
                          <div className={styles.rateAgreementDoc} key={index}>
                            <img
                              src={drawerContents[item][1]}
                              className={styles.imageSize}
                              alt=""
                            />
                            <span
                              className={styles.label}
                              onClick={() =>
                                downloadUtil(
                                  Object.values(documentData[item])?.[index],
                                )
                              }
                            >
                              {`${drawerContents[item][2]}${index + 1}.pdf`}
                            </span>
                          </div>
                        ),
                      )}
                  </>
                )}
              </div>
            </div>
          ))}
      </Drawer>
    </>
  );
};

export default FileListDrawer;
